// -------------------------------------------
//   ANIMATIONS > FLIP
// -------------------------------------------
import { replacePXinStringWithEM } from 'utils/styles/style_helpers';



// (((((((((( ~~~~~~~~~~ FLIP ~~~~~~~~~~ )))))))))) //
const flip = {
	'@global': {
		// ***** FLIP (horizontal) ***** //
		'@keyframes flip': {
			from: {
				transform: replacePXinStringWithEM('perspective(400px) rotate3d(0, 1, 0, -360deg)'),
				animationTimingFunction: 'ease-out'
			},
			'40%': {
				transform: replacePXinStringWithEM('perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg)'),
				animationTimingFunction: 'ease-out'
			},
			'50%': {
				transform: replacePXinStringWithEM('perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg)'),
				animationTimingFunction: 'ease-in'
			},
			'80%': {
				transform: replacePXinStringWithEM('perspective(400px) scale3d(.95, .95, .95)'),
				animationTimingFunction: 'ease-in'
			},
			to: {
				transform: replacePXinStringWithEM('perspective(400px)'),
				animationTimingFunction: 'ease-in'
			}
		}
	}
};


// (((((((((( ~~~~~~~~~~ FLIP IN ~~~~~~~~~~ )))))))))) //
const flipIn = {
	'@global': {
		// ***** FLIP : IN : Y ***** //
		'@keyframes flipInY': {
			from: {
				transform: replacePXinStringWithEM('perspective(400px) rotate3d(1, 0, 0, 90deg)'),
				animationTimingFunction: 'ease-in',
				opacity: '0'
			},
			'40%': {
				transform: replacePXinStringWithEM('perspective(400px) rotate3d(1, 0, 0, -20deg)'),
				animationTimingFunction: 'ease-in',
			},
			'60%': {
				transform: replacePXinStringWithEM('perspective(400px) rotate3d(1, 0, 0, 10deg)'),
				opacity: '1'
			},
			'80%': {
				transform: replacePXinStringWithEM('perspective(400px) rotate3d(1, 0, 0, -5deg)'),
			},
			to: {
				transform: replacePXinStringWithEM('perspective(400px)'),
			}
		},
		// ***** FLIP : IN : X ***** //
		'@keyframes flipInX': {
			from: {
				transform: replacePXinStringWithEM('perspective(400px) rotate3d(0, 1, 0, 90deg)'),
				animationTimingFunction: 'ease-in',
				opacity: '0'
			},
			'40%': {
				transform: replacePXinStringWithEM('perspective(400px) rotate3d(0, 1, 0, -20deg)'),
				animationTimingFunction: 'ease-in'
			},
			'60%': {
				transform: replacePXinStringWithEM('perspective(400px) rotate3d(0, 1, 0, 10deg)'),
				opacity: '1'
			},
			'80%': {
				transform: replacePXinStringWithEM('perspective(400px) rotate3d(0, 1, 0, -5deg)'),
			},
			to: {
				transform: replacePXinStringWithEM('perspective(400px)'),
			}
		}
	}
};


// (((((((((( ~~~~~~~~~~ FLIP OUT ~~~~~~~~~~ )))))))))) //
const flipOut = {
	'@global': {
		// ***** FLIP : OUT : Y ***** //
		'@keyframes flipOutY': {
			from: {
				transform: replacePXinStringWithEM('perspective(400px)')
			},
			'30%': {
				transform: replacePXinStringWithEM('perspective(400px) rotate3d(0, 1, 0, -15deg)'),
				opacity: '1'
			},
			to: {
				transform: replacePXinStringWithEM('perspective(400px) rotate3d(0, 1, 0, 90deg)'),
				opacity: '0'
			}
		},
		// ***** FLIP : OUT : X ***** //
		'@keyframes flipOutX': {
			from: {
				transform: replacePXinStringWithEM('perspective(400px)')
			},
			'30%': {
				transform: replacePXinStringWithEM('perspective(400px) rotate3d(1, 0, 0, -20deg)'),
				opacity: '1'
			},
			to: {
				transform: replacePXinStringWithEM('perspective(400px) rotate3d(1, 0, 0, 90deg)'),
				opacity: '0'
			}
		}
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export { flip, flipIn, flipOut };